import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { addEventListener, jsonp } from '@ifeng/ui_base';
import { Player } from 'ThreeTerminal_pc';
import Footer from '../../../components/footer/';
import bigLogo from './assets/bigLogo.png';
import logoGroup from './assets/logoGroup.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.css';
import { footer } from './assets/data';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    return result;
};

const pickPeriod = (props, name) => {
    const { content } = props;
    const period = [];
    let length = 0;

    content.modules.forEach(item => {
        if (item.title.indexOf(name) > -1) {
            period[+item.title.split('-')[1]] = item.data.articleList;
        }
    });
    period.shift();
    length = period.length - 1;
    if (period.length < 12) {
        while (period.length < 12) {
            period.push({ flag: 1 });
        }
    }

    return { period, length };
};
let unHandleScroll = () => {};
// 视频+君品故事
const PartOne = errorBoundary(props => {
    const { period: gushiList, length: index } = pickPeriod(props, '君品故事');
    // 当前选中的视频
    const [activeIndex, setActiveIndex] = useState('0_0');
    // 君品故事的期数
    const [periodIndex, setPeriodIndex] = useState(index);
    // 哈希导航
    const [navIndex, setNavIndex] = useState(0);
    const [videoPlay, setVideoPlay] = useState(true);
    // 正片和精彩看点
    const [column, setColumn] = useState('zhengpian');
    // 导航吸顶
    const [fixed, setFixed] = useState(false);
    // 播放量
    const [playNum, setPlayNum] = useState(0);
    // 正片url
    const zhengpianUrl = pickContent(props, '观看正片')[0].url;
    const zhengpian = pickContent(props, '节目正片');
    const kandian = pickContent(props, '精彩看点').concat(pickContent(props, '精彩看点2'));
    const navImg = ['gushi', 'shunjian', 'pindu', 'gonghua', 'zhengpian'];
    const getVideoInfo = _ => {
        const list = +activeIndex.split('_')[1] === 0 ? zhengpian : kandian;
        const index = activeIndex.split('_')[0];

        return [list[index].thumbnail, list[index].videoPlayUrl, list[index].duration, list[index].guid];
    };
    const videoInfo = getVideoInfo();
    // 获取播放量
    const getVideoComment = async vid => {
        let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

        // 接口拼接
        if (vid.length > 0) {
            vid.forEach(item => {
                apiUrl += `key[]=${item}&`;
            });
        }
        let data = await jsonp(apiUrl, {
            data: {
                format: 'js',
                serviceid: 1,
            },
            jsonpCallback: 'getVideoComment1',
            cache: false,
        });

        data = data.data.browse[vid];
        setPlayNum(data);
    };
    const changeVideo = index => {
        if (activeIndex !== index) {
            window.videoOrderList = undefined;
            setVideoPlay(false);
            setActiveIndex(index);
        }
    };
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        initialSlide: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const formateData = [];
    const tempList = gushiList[periodIndex].concat();

    tempList.shift();
    tempList.forEach((item, index) => {
        const key = parseInt(index / 4);

        item.num = tempList.length - index < 10 ? `0${tempList.length - index}` : tempList.length - index;

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });
    formateData.forEach((item, index) => {
        while (formateData[index].length < 4) {
            formateData[index].push('');
        }
    });
    const changeNav = (item, index) => {
        if (item !== 'zhengpian') {
            setNavIndex(index);
            location.hash = item;
        } else {
            window.open(zhengpianUrl);
        }
    };
    const changePeriod = (item, index) => {
        setPeriodIndex(index);
    };
    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        if (scrollTop > 690) {
            setFixed(true);
        } else {
            setFixed(false);
        }
    };

    useEffect(
        () => {
            setVideoPlay(true);
            // getVideoComment([videoInfo[3]]);
        },
        [activeIndex],
    );
    useEffect(() => {
        // 绑定监听滚动
        unHandleScroll = addEventListener(window, 'scroll', handleScroll);
        // 获取观看量
        // getVideoComment([videoInfo[3]]);
    }, []);
    // 自动播放下一个视频
    const playNextVideo = _ => {
        // 判断是否存在下一个视频
        const list = +activeIndex.split('_')[1] === 0 ? zhengpian : kandian;
        const index = +activeIndex.split('_')[0];

        if (index + 1 < list.length) {
            changeVideo(`${index + 1}_${activeIndex.split('_')[1]}`);
        }
    };

    return (
        <div className={styles.part_one}>
            <div className={styles.video_container}>
                <img className={styles.big_logo} src={bigLogo} />
                <img className={styles.logo_group} src={logoGroup} />
                <div>
                    <div className={styles.video}>
                        {videoPlay ? (
                            <Player
                                videoConfig={{
                                    videoLargePoster: videoInfo[0],
                                    videoPlayUrl: videoInfo[1],
                                    duration: +videoInfo[2],
                                    vid: videoInfo[3],
                                }}
                                playermsg={{
                                    subject: '2020dfjpt',
                                    adType: 2,
                                    width: 768,
                                    height: 432,
                                    isAuth: 'auth',
                                    frmid: 'v',
                                    autoPlay: true,
                                    playerEventTrigger: playerEvents => {
                                        playerEvents.on('ended', () => {
                                            playNextVideo();
                                        });
                                    },
                                }}
                            />
                        ) : null}
                    </div>
                    <div className={styles.video_list}>
                        <div className={styles.video_type}>
                            <div
                                className={column === 'zhengpian' ? styles.active : ''}
                                onMouseEnter={_ => setColumn('zhengpian')}>
                                节目正片
                            </div>
                            <div
                                className={column === 'kandian' ? styles.active : ''}
                                onMouseEnter={_ => setColumn('kandian')}>
                                精彩看点
                            </div>
                        </div>
                        <div className={styles.list_container}>
                            {column === 'zhengpian'
                                ? zhengpian.map((item, index) => {
                                      return (
                                          <div
                                              className={`${styles.list_item} ${
                                                  activeIndex === `${index}_0` ? styles.list_item_active : ''
                                              }`}
                                              key={`${index}_1`}
                                              title={item.title}
                                              onClick={_ => changeVideo(`${index}_0`)}>
                                              <span>{item.title}</span>
                                          </div>
                                      );
                                  })
                                : kandian.map((item, index) => {
                                      return (
                                          <div
                                              className={`${styles.list_item} ${
                                                  activeIndex === `${index}_1` ? styles.list_item_active : ''
                                              }`}
                                              key={`${index}_1`}
                                              title={item.title}
                                              onClick={_ => changeVideo(`${index}_1`)}>
                                              <span>{item.title}</span>
                                          </div>
                                      );
                                  })}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.nav} id="nav">
                {navImg.map((item, index) => (
                    <div
                        className={styles.nav_item}
                        key={item}
                        onClick={changeNav.bind(this, item, index)}
                        style={
                            navIndex === index
                                ? { backgroundImage: `url(${require(`./assets/${item}Active.png`)})` }
                                : { backgroundImage: `url(${require(`./assets/${item}.png`)})` }
                        }
                    />
                ))}
            </div>
            <div className={styles.nav_fixed} style={fixed ? {} : { display: 'none' }}>
                <div className={styles.nav}>
                    {navImg.map((item, index) => (
                        <div
                            className={styles.nav_item}
                            key={item}
                            onClick={changeNav.bind(this, item, index)}
                            style={
                                navIndex === index
                                    ? { backgroundImage: `url(${require(`./assets/${item}Active.png`)})` }
                                    : { backgroundImage: `url(${require(`./assets/${item}.png`)})` }
                            }
                        />
                    ))}
                </div>
            </div>

            <div
                className={styles.title}
                id="gushi"
                style={{ backgroundImage: `url(${require('./assets/gushiTitle.png')})` }}
            />
            <div className={styles.gushi}>
                <div className={styles.period_container}>
                    {gushiList.map((item, index) => {
                        if (item.flag === 1) {
                            return <div className={styles.period_unable} key={index}>{`第${index + 1}期`}</div>;
                        } else if (item.flag === 2) {
                            return <div className={styles.period} key={index} />;
                        } else {
                            return (
                                <div
                                    className={periodIndex === index ? styles.period_active : styles.period}
                                    key={index}
                                    onClick={changePeriod.bind(this, item, index)}>{`第${index + 1}期`}</div>
                            );
                        }
                    })}
                </div>
                <div className={styles.gushi_video_container}>
                    <div
                        className={styles.left_video}
                        onClick={_ => {
                            window.open(gushiList[periodIndex][0].url);
                        }}>
                        <img src={gushiList[periodIndex][0]?.thumbnail} />
                        <div className={styles.info}>
                            <div>{gushiList[periodIndex][0]?.title}</div>
                        </div>
                    </div>
                    <div className={styles.right_video_container}>
                        <div
                            className={styles.slide_pre}
                            onClick={() => {
                                slide.current.slickPrev();
                            }}
                        />
                        <div className={styles.slide_next} onClick={() => slide.current.slickNext()} />
                        <Slider {...settings} ref={slider => (slide.current = slider)}>
                            {formateData.map((item, _index) => {
                                return (
                                    <div key={_index} className={styles.gushi_slide_container}>
                                        {item.map((card, index) => {
                                            if (card) {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={styles.gushi_slide_item}
                                                        onClick={() => window.open(card.url, '_blank')}>
                                                        <img src={card.thumbnail} />
                                                        <div className={styles.gushi_info}>
                                                            <div>{card.title}</div>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return <div key={index} className={styles.gushi_slide_item} />;
                                            }
                                        })}
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
});
// 君品瞬间
const PartTwo = errorBoundary(props => {
    const { period: shunjianList, length: index } = pickPeriod(props, '君品瞬间');
    const [periodIndex, setPeriodIndex] = useState(index);
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const formateData = [];
    const tempList = shunjianList[periodIndex];

    tempList.forEach((item, index) => {
        const key = parseInt(index / 4);

        item.num = tempList.length - index < 10 ? `0${tempList.length - index}` : tempList.length - index;

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });
    formateData.forEach((item, index) => {
        while (formateData[index].length < 4) {
            formateData[index].push('');
        }
    });
    const changePeriod = (item, index) => {
        setPeriodIndex(index);
    };

    return (
        <div className={styles.part_two}>
            <div
                className={styles.title}
                id="shunjian"
                style={{ backgroundImage: `url(${require('./assets/shunjianTitle.png')})` }}
            />
            <div className={styles.shunjian}>
                <div className={styles.period_container}>
                    {shunjianList.map((item, index) => {
                        if (item.flag === 1) {
                            return <div className={styles.period_unable} key={index}>{`第${index + 1}期`}</div>;
                        } else if (item.flag === 2) {
                            return <div className={styles.period} key={index} />;
                        } else {
                            return (
                                <div
                                    className={periodIndex === index ? styles.period_active : styles.period}
                                    key={index}
                                    onClick={changePeriod.bind(this, item, index)}>{`第${index + 1}期`}</div>
                            );
                        }
                    })}
                </div>
                <div
                    className={styles.slide_pre}
                    onClick={() => {
                        slide.current.slickPrev();
                    }}
                />
                <div className={styles.slide_next} onClick={() => slide.current.slickNext()} />
                <Slider {...settings} ref={slider => (slide.current = slider)}>
                    {formateData.map((item, _index) => {
                        return (
                            <div key={_index} className={styles.shunjian_slide_container}>
                                {item.map((card, index) => {
                                    if (card) {
                                        return (
                                            <div
                                                key={index}
                                                className={styles.shunjian_slide_item}
                                                onClick={() =>
                                                    window.open(`${card.url}#p=${_index * 4 + index + 1}`, '_blank')
                                                }>
                                                <img src={card.thumbnail} alt="" />
                                            </div>
                                        );
                                    } else {
                                        return <div key={index} className={styles.shunjian_slide_item} />;
                                    }
                                })}
                            </div>
                        );
                    })}
                </Slider>
                <div>
                    <div />
                    <div />
                </div>
            </div>
        </div>
    );
});
// 君品品读+君品答谢+公话君品
const PartThree = errorBoundary(props => {
    const pindu = pickContent(props, '君品品读');

    return (
        <div className={styles.part_three}>
            <div className={styles.pindu} id="pindu">
                <div
                    className={styles.title}
                    style={{ backgroundImage: `url(${require('./assets/pinduTitle.png')})`, marginTop: 35 }}
                />
                <div className={styles.pindu_list}>
                    {/* {pindu.length ? '' : (<div className={styles.qidai}>敬请期待</div>)} */}
                    {pindu.map((item, index) => (
                        <div
                            className={styles.pindu_item}
                            key={index}
                            title={item.title}
                            onClick={_ => {
                                window.open(item.url, '_blank');
                            }}>
                            {item.title}
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.daxie}>
                <div
                    className={styles.title}
                    style={{ backgroundImage: `url(${require('./assets/daxieTitle.png')})` }}
                />
                <div
                    className={styles.daxie_logo}
                    style={{ backgroundImage: `url(${require('./assets/logo.png')})`, cursor: 'pointer' }}
                    onClick={_ => {
                        window.open('https://www.gzxijiu.com/', '_blank');
                    }}
                />
            </div>

            <div className={styles.gonghua} id="gonghua">
                <div
                    className={styles.title}
                    style={{ backgroundImage: `url(${require('./assets/gonghuaTitle.png')})`, marginBottom: 53 }}
                />
                {/* https://widget.weibo.com/topics/topic_vote_base.php?tag=%E6%B6%82%E6%96%99&isshowright=1&color=333,fff,013979,cccccc,333333,ffffff,0078b6,cccccc,cccccc,e9f4fb&rightwidth=250&height=600&width=940&widgetcolor=f2f2f2&leftcolor=333&leftbgcolor=fff&leftlinkcolor=013979&is_width=1 */}
                {/* https://widget.weibo.com/topics/topic_vote_base.php?tag=%E9%93%B6%E8%A1%8C%E4%B8%9A%E5%8F%91%E5%B1%95%E8%AE%BA%E5%9D%9B&isshowright=&color=333333,ffffff,0078b6,cccccc,333333,ffffff,0078b6,cccccc,cccccc,e9f4fb&width=1000&height=600 */}
                <div className={styles.iframe_container}>
                    <iframe
                        src="http://widget.weibo.com/topics/topic_vote_base.php?uid=7344100169&amp;border=0&amp;footbar=1
                        &amp;width=821&amp;height=369&amp;language=zh_cn&amp;version=base
                        &amp;isshowright=1&amp;tag=%E5%90%9B%E5%93%81%E8%B0%88
                        "
                        width="821"
                        height="1080"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                    />
                </div>
            </div>
        </div>
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const banner = pickContent(this.props, 'banner');

        return (
            <div className={styles.junpintan}>
                <PartOne content={content} />
                <img
                    className={styles.banner}
                    src={banner[0].thumbnail}
                    onClick={_ => {
                        window.open(banner[0].url, '_blank');
                    }}
                />
                <PartTwo content={content} />
                <PartThree content={content} />
                <Footer content={footer.content} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
